export enum KnowledgeCardsRowType {
	PERSON = 'PERSON',
	WORK = 'WORK',
	AGENT = 'AGENT',
}
